import {
  AxiosError,
  AxiosInterceptorManager,
  AxiosResponse,
  InternalAxiosRequestConfig,
} from 'axios';

export const hasAnyCodeInterceptor =
  (code: number, redirect: string, exclude: Set<string>) =>
  (manager: AxiosInterceptorManager<AxiosResponse>) =>
    manager.use(
      (res) => res,
      (err: AxiosError<InternalAxiosRequestConfig>) => {
        const status = err.response?.status;

        if (err.config?.withAuthorization === false) {
          return Promise.reject(err);
        }

        // Проверяем, есть ли ответ с ошибкой
        if (status && status === code) {
          if (
            !exclude.has(window.location.pathname) &&
            window.location.pathname !== redirect
          ) {
            window.location.href = redirect;
            return Promise.reject(err);
          }
        }

        return Promise.reject(err);
      },
    );
